/* eslint-disable */

import request from '@/utils/request'

export function getIPTVApi(query) {
  return request({
    url: '/config-service/v1/config/iptv',
    method: 'get',
    params: query
  })
}
export function getTokenIPTVApi(query) {
  return request({
    url: '/config-service/v1/config/iptv/token',
    method: 'get',
    params: query
  })
}


export function updateIPTVApi(query) {
  return request({
    url: '/config-service/v1/config/iptv',
    method: 'put',
    data: query
  })
}

